import { useScreen } from '@/hooks/useScreen';
import { ICollectionItem } from '@/interfaces/doccen-lib/collection.interface';
import { AxiosError } from 'axios';
import { Button } from 'design-system/components/Button';
import { Typography } from 'design-system/components/Typography';
import dynamic from 'next/dynamic';
import { ComponentPropsWithoutRef } from 'react';
import { UseInfiniteQueryResult } from 'react-query';
import { twMerge } from 'tailwind-merge';

const LibraryCollectionsGalleryDesktop = dynamic(
  () => import('./components/collections/DisplayCollectionsGalleryDesktop')
);
const LibraryCollectionsGalleryMobile = dynamic(
  () => import('./components/collections/DisplayCollectionsGalleryMobile')
);

const DisplayCollectionsGallery = ({
  query,
  title,
  onClickExpand,
  expandable = true,
  notFound,
  galleryProps,
  gridMode,
  ...props
}: {
  query: UseInfiniteQueryResult<ICollectionItem, AxiosError>;
  title: React.ReactNode;
  onClickExpand: () => void;
  expandable?: boolean;
  notFound: React.ReactNode | null;
  gridMode?: boolean;
  galleryProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
  virtual?: boolean;
} & Omit<ComponentPropsWithoutRef<'div'>, 'title'>) => {
  const { isMobile, isTablet } = useScreen();

  return (
    <div {...props} className={twMerge(props.className)}>
      <div className="flex items-center justify-between">
        <Typography variant="display2.5">{title}</Typography>
        {expandable && !!query.data?.pages?.length && (
          <Button onClick={onClickExpand} emphasis="medium" size="small">
            Xem thêm
          </Button>
        )}
      </div>
      <div>
        {!!query.data?.pages?.length || query.isFetching ? (
          (isMobile || isTablet) && !gridMode ? (
            <LibraryCollectionsGalleryMobile query={query} {...galleryProps} />
          ) : (
            <LibraryCollectionsGalleryDesktop query={query} {...galleryProps} />
          )
        ) : (
          notFound
        )}
      </div>
    </div>
  );
};

export default DisplayCollectionsGallery;
